import React from 'react';
import { Card, CardContent } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import styles from '../styles';
import ErrorMessage from '../../../components/ErrorMessage/ErrorMessage';

interface ErrorCardProps {
  errorMessage: string;
}

function ErrorCard({ errorMessage }: ErrorCardProps): React.ReactElement {
  return (
    <Card sx={{ ...styles.errorCard, height: 300 }}>
      <CardContent sx={{ textAlign: 'center' }}>
        <WarningIcon color='error' fontSize='large' sx={{ mb: 2 }} />
        <ErrorMessage message={errorMessage} />
      </CardContent>
    </Card>
  );
}

export default ErrorCard;
